import SalesSlipPage from './SalesSlipPage';

export default SalesSlipPage;
